module.exports = __webpack_public_path__ + "static/media/AccountActivatedTablet.7f9e5108.svg";